import { ReactElement } from 'react';

import { EmptyStatePlaceholder, Table } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';

import {
   useConsentsAndAuthorizationsDocumentsDataConfiguration,
   useConsentsAndAuthorizationsDocumentsTableColumns,
} from './ConsentsAndAuthorizationsDocumentsTable.hooks';

const t = patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.modal.form.table;

type ConsentsAndAuthorizationsDocumentsTableProps = {
   readonly onApproveAndPrint: VoidFunction;
   readonly patientId: number;
   readonly searchText: string | null;
};

export const ConsentsAndAuthorizationsDocumentsTable = (
   props: ConsentsAndAuthorizationsDocumentsTableProps
): ReactElement => {
   const dataConfiguration = useConsentsAndAuthorizationsDocumentsDataConfiguration({ searchText: props.searchText });
   const columns = useConsentsAndAuthorizationsDocumentsTableColumns({
      onApproveAndPrint: props.onApproveAndPrint,
      onFavoriteChange: dataConfiguration.refetch,
      patientId: props.patientId,
   });

   return (
      <Table
         columns={columns}
         dataConfiguration={dataConfiguration}
         testId={'consentsAndAuthorizationsDocumentsTable'}
         keyExtractor={'id'}
         placeholder={
            <EmptyStatePlaceholder
               heading={t.noConsentsAndAuthorizationsDocumentsPlaceholder}
               testId={'noConsentsAndAuthorizationsDocuments'}
            />
         }
      />
   );
};
